/**
 * @generated SignedSource<<3ff6cb0845a1830b8fbf0f1c32684c6d>>
 * @relayHash 16cf2817ba9995def1dd99137aedf193
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID a759e5523ae3d9df771a1e69c25ddb486a989da6f175642a661e28640b9b016c

import type { ConcreteRequest } from 'relay-runtime';
export type SaveFilterDialogBaseQuery$variables = {
  filterAri: string;
  includeFilter: boolean;
};
export type SaveFilterDialogBaseQuery$data = {
  readonly jira: {
    readonly filter?: {
      readonly description?: string | null;
      readonly editGrants?: {
        readonly edges: ReadonlyArray<{
          readonly node: {
            readonly __typename: "JiraShareableEntityGroupGrant";
            readonly group: {
              readonly id: string;
              readonly name: string;
            };
          } | {
            readonly __typename: "JiraShareableEntityProjectGrant";
            readonly project: {
              readonly avatar: {
                readonly xsmall: string | null;
              } | null;
              readonly id: string;
              readonly name: string;
            };
          } | {
            readonly __typename: "JiraShareableEntityProjectRoleGrant";
            readonly project: {
              readonly avatar: {
                readonly xsmall: string | null;
              } | null;
              readonly id: string;
              readonly name: string;
            };
            readonly role: {
              readonly name: string | null;
              readonly roleId: string;
            };
          } | {
            readonly __typename: "JiraShareableEntityUnknownProjectGrant";
            readonly __typename: "JiraShareableEntityUnknownProjectGrant";
          } | {
            readonly __typename: "JiraShareableEntityUserGrant";
            readonly user: {
              readonly accountId: string;
              readonly name: string;
              readonly picture: AGG$URL;
            };
          } | {
            // This will never be '%other', but we need some
            // value in case none of the concrete values match.
            readonly __typename: "%other";
          } | null;
        } | null> | null;
      } | null;
      readonly id?: string;
      readonly jql?: string;
      readonly name?: string;
      readonly shareGrants?: {
        readonly edges: ReadonlyArray<{
          readonly node: {
            readonly __typename: "JiraShareableEntityAnonymousAccessGrant";
            readonly __typename: "JiraShareableEntityAnonymousAccessGrant";
          } | {
            readonly __typename: "JiraShareableEntityAnyLoggedInUserGrant";
            readonly __typename: "JiraShareableEntityAnyLoggedInUserGrant";
          } | {
            readonly __typename: "JiraShareableEntityGroupGrant";
            readonly group: {
              readonly id: string;
              readonly name: string;
            };
          } | {
            readonly __typename: "JiraShareableEntityProjectGrant";
            readonly project: {
              readonly avatar: {
                readonly xsmall: string | null;
              } | null;
              readonly id: string;
              readonly name: string;
            };
          } | {
            readonly __typename: "JiraShareableEntityProjectRoleGrant";
            readonly project: {
              readonly avatar: {
                readonly xsmall: string | null;
              } | null;
              readonly id: string;
              readonly name: string;
            };
            readonly role: {
              readonly name: string | null;
              readonly roleId: string;
            };
          } | {
            readonly __typename: "JiraShareableEntityUnknownProjectGrant";
            readonly __typename: "JiraShareableEntityUnknownProjectGrant";
          } | {
            readonly __typename: "JiraShareableEntityUserGrant";
            readonly user: {
              readonly accountId: string;
              readonly name: string;
              readonly picture: AGG$URL;
            };
          } | {
            // This will never be '%other', but we need some
            // value in case none of the concrete values match.
            readonly __typename: "%other";
          } | null;
        } | null> | null;
      } | null;
    } | null;
  } | null;
};
export type SaveFilterDialogBaseQuery = {
  response: SaveFilterDialogBaseQuery$data;
  variables: SaveFilterDialogBaseQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "filterAri"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "includeFilter"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "filterAri"
  }
],
v2 = {
  "kind": "ScalarField",
  "name": "id"
},
v3 = {
  "kind": "ScalarField",
  "name": "name"
},
v4 = {
  "kind": "ScalarField",
  "name": "description"
},
v5 = {
  "kind": "ScalarField",
  "name": "jql"
},
v6 = {
  "kind": "ScalarField",
  "name": "__typename"
},
v7 = {
  "concreteType": "JiraAvatar",
  "kind": "LinkedField",
  "name": "avatar",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "xsmall"
    }
  ]
},
v8 = {
  "kind": "RequiredField",
  "field": {
    "concreteType": "JiraProject",
    "kind": "LinkedField",
    "name": "project",
    "plural": false,
    "selections": [
      {
        "kind": "RequiredField",
        "field": (v2/*: any*/),
        "action": "THROW"
      },
      (v3/*: any*/),
      (v7/*: any*/)
    ]
  },
  "action": "THROW"
},
v9 = {
  "kind": "ScalarField",
  "name": "roleId"
},
v10 = {
  "kind": "RequiredField",
  "field": {
    "concreteType": "JiraRole",
    "kind": "LinkedField",
    "name": "role",
    "plural": false,
    "selections": [
      (v9/*: any*/),
      (v3/*: any*/)
    ]
  },
  "action": "THROW"
},
v11 = {
  "concreteType": "JiraGroup",
  "kind": "LinkedField",
  "name": "group",
  "plural": false,
  "selections": [
    (v2/*: any*/),
    (v3/*: any*/)
  ]
},
v12 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "kind": "RequiredField",
      "field": (v11/*: any*/),
      "action": "THROW"
    }
  ],
  "type": "JiraShareableEntityGroupGrant"
},
v13 = {
  "kind": "ScalarField",
  "name": "accountId"
},
v14 = {
  "kind": "ScalarField",
  "name": "picture"
},
v15 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "kind": "RequiredField",
      "field": {
        "kind": "LinkedField",
        "name": "user",
        "plural": false,
        "selections": [
          (v13/*: any*/),
          (v3/*: any*/),
          (v14/*: any*/)
        ]
      },
      "action": "THROW"
    }
  ],
  "type": "JiraShareableEntityUserGrant"
},
v16 = {
  "concreteType": "JiraProject",
  "kind": "LinkedField",
  "name": "project",
  "plural": false,
  "selections": [
    (v2/*: any*/),
    (v3/*: any*/),
    (v7/*: any*/)
  ]
},
v17 = {
  "kind": "RequiredField",
  "field": (v16/*: any*/),
  "action": "THROW"
},
v18 = [
  {
    "kind": "LinkedField",
    "name": "node",
    "plural": false,
    "selections": [
      (v6/*: any*/),
      {
        "kind": "InlineFragment",
        "selections": [
          (v16/*: any*/)
        ],
        "type": "JiraShareableEntityProjectGrant"
      },
      {
        "kind": "InlineFragment",
        "selections": [
          (v16/*: any*/),
          {
            "concreteType": "JiraRole",
            "kind": "LinkedField",
            "name": "role",
            "plural": false,
            "selections": [
              (v9/*: any*/),
              (v3/*: any*/),
              (v2/*: any*/)
            ]
          }
        ],
        "type": "JiraShareableEntityProjectRoleGrant"
      },
      {
        "kind": "InlineFragment",
        "selections": [
          (v11/*: any*/)
        ],
        "type": "JiraShareableEntityGroupGrant"
      },
      {
        "kind": "InlineFragment",
        "selections": [
          {
            "kind": "LinkedField",
            "name": "user",
            "plural": false,
            "selections": [
              (v6/*: any*/),
              (v13/*: any*/),
              (v3/*: any*/),
              (v14/*: any*/),
              (v2/*: any*/)
            ]
          }
        ],
        "type": "JiraShareableEntityUserGrant"
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "SaveFilterDialogBaseQuery",
    "selections": [
      {
        "concreteType": "JiraQuery",
        "kind": "LinkedField",
        "name": "jira",
        "plural": false,
        "selections": [
          {
            "condition": "includeFilter",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
              {
                "args": (v1/*: any*/),
                "kind": "LinkedField",
                "name": "filter",
                "plural": false,
                "selections": [
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      (v2/*: any*/),
                      (v3/*: any*/),
                      (v4/*: any*/),
                      (v5/*: any*/),
                      {
                        "concreteType": "JiraShareableEntityShareGrantConnection",
                        "kind": "LinkedField",
                        "name": "shareGrants",
                        "plural": false,
                        "selections": [
                          {
                            "concreteType": "JiraShareableEntityShareGrantEdge",
                            "kind": "LinkedField",
                            "name": "edges",
                            "plural": true,
                            "selections": [
                              {
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                  (v6/*: any*/),
                                  {
                                    "kind": "InlineFragment",
                                    "selections": [
                                      (v8/*: any*/)
                                    ],
                                    "type": "JiraShareableEntityProjectGrant"
                                  },
                                  {
                                    "kind": "InlineFragment",
                                    "selections": [
                                      (v8/*: any*/),
                                      (v10/*: any*/)
                                    ],
                                    "type": "JiraShareableEntityProjectRoleGrant"
                                  },
                                  (v12/*: any*/),
                                  (v15/*: any*/)
                                ]
                              }
                            ]
                          }
                        ]
                      },
                      {
                        "concreteType": "JiraShareableEntityEditGrantConnection",
                        "kind": "LinkedField",
                        "name": "editGrants",
                        "plural": false,
                        "selections": [
                          {
                            "concreteType": "JiraShareableEntityEditGrantEdge",
                            "kind": "LinkedField",
                            "name": "edges",
                            "plural": true,
                            "selections": [
                              {
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                  (v6/*: any*/),
                                  {
                                    "kind": "InlineFragment",
                                    "selections": [
                                      (v17/*: any*/)
                                    ],
                                    "type": "JiraShareableEntityProjectGrant"
                                  },
                                  {
                                    "kind": "InlineFragment",
                                    "selections": [
                                      (v17/*: any*/),
                                      (v10/*: any*/)
                                    ],
                                    "type": "JiraShareableEntityProjectRoleGrant"
                                  },
                                  (v12/*: any*/),
                                  (v15/*: any*/)
                                ]
                              }
                            ]
                          }
                        ]
                      }
                    ],
                    "type": "JiraCustomFilter"
                  }
                ]
              }
            ]
          }
        ]
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "SaveFilterDialogBaseQuery",
    "selections": [
      {
        "concreteType": "JiraQuery",
        "kind": "LinkedField",
        "name": "jira",
        "plural": false,
        "selections": [
          {
            "condition": "includeFilter",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
              {
                "args": (v1/*: any*/),
                "kind": "LinkedField",
                "name": "filter",
                "plural": false,
                "selections": [
                  (v6/*: any*/),
                  (v2/*: any*/),
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      (v3/*: any*/),
                      (v4/*: any*/),
                      (v5/*: any*/),
                      {
                        "concreteType": "JiraShareableEntityShareGrantConnection",
                        "kind": "LinkedField",
                        "name": "shareGrants",
                        "plural": false,
                        "selections": [
                          {
                            "concreteType": "JiraShareableEntityShareGrantEdge",
                            "kind": "LinkedField",
                            "name": "edges",
                            "plural": true,
                            "selections": (v18/*: any*/)
                          }
                        ]
                      },
                      {
                        "concreteType": "JiraShareableEntityEditGrantConnection",
                        "kind": "LinkedField",
                        "name": "editGrants",
                        "plural": false,
                        "selections": [
                          {
                            "concreteType": "JiraShareableEntityEditGrantEdge",
                            "kind": "LinkedField",
                            "name": "edges",
                            "plural": true,
                            "selections": (v18/*: any*/)
                          }
                        ]
                      }
                    ],
                    "type": "JiraCustomFilter"
                  }
                ]
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "id": "a759e5523ae3d9df771a1e69c25ddb486a989da6f175642a661e28640b9b016c",
    "metadata": {},
    "name": "SaveFilterDialogBaseQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "13c80ddfcaeb532571af08e52058efee";

export default node;
